export const formatDateDisplay = (date?: string | Date): string => {
  if (!date) return "";

  return new Intl.DateTimeFormat("fr-FR", {
    dateStyle: "short",
  }).format(new Date(date));
};